module.exports = __webpack_public_path__ + "img/tasks_black.6ed2f43c.png";